import { createRouter, createWebHistory } from 'vue-router'

import eventBus from '@/plugins/eventBus'

import { setPageHeader } from '@/helpers/pageHelper'

// import routes from '@/config/routesConfig'
import BASE_LEVEL from '@/config/router/routerConfig.js'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: BASE_LEVEL,
})

router.beforeEach((to, from, next) => {
	if (to.path !== from.path) {
		setPageHeader()
	}
	if (from.name !== undefined && from.name !== to.name && to.meta.isDynamicComponent) {
		eventBus.$emit('navigationRouterLinkLoading', {
			name: to.name,
			status: 'start',
		})
	}
	next()
})

router.beforeResolve((to, from, next) => {
	eventBus.$emit('navigationRouterLinkLoading', {
		name: to.name,
		status: 'end',
	})
	next()
})

export default router
